import { GenIcon } from '../helpers/IconBase.es.js';

const MonitorOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 4.75C4.30964 4.75 3.75 5.30964 3.75 6V15.5C3.75 16.1904 4.30964 16.75 5 16.75H19.5C20.1904 16.75 20.75 16.1904 20.75 15.5V6C20.75 5.30964 20.1904 4.75 19.5 4.75H5ZM2.25 6C2.25 4.48122 3.48122 3.25 5 3.25H19.5C21.0188 3.25 22.25 4.48122 22.25 6V15.5C22.25 17.0188 21.0188 18.25 19.5 18.25H13V19.25C13 19.3377 12.985 19.4218 12.9573 19.5H18.25C18.6642 19.5 19 19.8358 19 20.25C19 20.6642 18.6642 21 18.25 21H6.25C5.83579 21 5.5 20.6642 5.5 20.25C5.5 19.8358 5.83579 19.5 6.25 19.5H11.5427C11.515 19.4218 11.5 19.3377 11.5 19.25V18.25H5C3.48122 18.25 2.25 17.0188 2.25 15.5V6Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { MonitorOutlined };
